<template>
<div style="display: flex;justify-content: center;width: 100%;height: 100%;overflow: auto">
  <div class="temp">

    <div class="tempTitle">
      <div class="divWidth32" style="color: white; font-size: 16px">
        <span>{{"报价编号:"}}</span>
        <el-select v-if="!this.parentData.content_json" style="width: 160px; color:white" class="quoteSelect" v-model="this.quoteJson" placeholder="选择报价" clearable="true"
                   filterable="true" @change="this.getQuoteJson">
          <el-option v-for="item in quote" :key="item.quote_no" :label="item.quote_no" :value="item.content_json"></el-option>
        </el-select>
        <span v-else>{{this.parentData.quote_no}}</span>
      </div>
      <div class="divWidth32 textAlignCenter" style="color: white; font-size: 24px">{{"报价单"}}</div>
      <div class="divWidth32" style="height: 100%; display: flex; justify-content: end">
        <img style="height: 100%;" src="../crm/icons/joysun.png"/>
      </div>
    </div>

    <div class="tempTitle textColor" style="height: 10%;background-color: whitesmoke;margin: 10px 0px">
      <div class="divWidth16">{{"报价日期"}}</div>
      <div class="divWidth32" style="text-align: center">{{this.currDate}}</div>
      <div class="divWidth16">{{"有效期至"}}</div>
      <div class="divWidth32" style="text-align: center">{{this.effectiveDay}}</div>
    </div>

    <div class="bottomLine" style="height:5%;display: flex; flex-direction: row; justify-content: space-between">
      <div class="textDiv divWidth16">{{"甲方"}}</div>
      <div class="divWidth32"></div>
      <div class="textDiv divWidth16">{{"乙方"}}</div>
      <div class="divWidth32"></div>
    </div>
    <div style="height: 6%; background-color: whitesmoke"></div>

    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div class="textColor divWidth16" style="line-height: 250%">{{"公司名称"}}</div>
      <div class="textColor divWidth32 textPadding" style="margin: auto">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.company_id" placeholder="选择公司"
                   filterable remote :remote-method="getCompanyByRemote"  @change="getCompanyInfo()">
          <el-option v-for="item in companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="textColor divWidth16" style="line-height: 250%">{{"公司名称"}}</div>
      <div class="textColor divWidth32 textPadding">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.selfCompanyId" placeholder="选择公司"
                   filterable="true" @visible-change="getSelfCompanyList" @change="getSelfCompany()">
          <el-option v-for="item in selfCompanyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <div style="display: flex; flex-direction: row;">
      <div class="textColor divWidth16" style="line-height: 250%">机会编号</div>
      <div class="textColor divWidth32 textPadding">
        <el-select :disabled="!buttonShow" v-model="busData.chanceId" placeholder="选择机会编号" @change="getPotentialByChance">
          <el-option v-for="item in chanceList" :key="item.id" :label="item.id" :value="item.id" ></el-option>
        </el-select>
      </div>
    </div>
    <div v-if="showPotential" style="display: flex; flex-direction: row;">
      <div class="textColor divWidth16" style="line-height: 250%">潜力产品</div>
      <div class="textColor divWidth32 textPadding">
        <el-select :disabled="!buttonShow" v-model="busData.potentialId" placeholder="选择潜力产品" >
          <el-option v-for="item in potentialList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div class="textColor divWidth16" style="line-height: 250%">{{"公司地址"}}</div>
      <div class="textColor divWidth32 textPadding">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.company_address" placeholder="选择地址"
                   filterable="true" >
          <el-option v-for="item in companyAddress" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="textColor divWidth16" style="line-height: 250%">{{"公司地址"}}</div>
      <div class="textColor divWidth32 textPadding" style="line-height: 250%">{{this.selfCompany.address}}</div>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div class="textColor divWidth16" style="line-height: 250%">{{"联  系  人"}}</div>
      <div class="textColor divWidth32">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.contactId" placeholder="选择联系人" clearable="true"
                   filterable="true"  @change="this.getContactPhone(contactList,busData.contactId)">
          <el-option v-for="item in contactList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="textColor divWidth16" style="line-height: 250%">{{"联  系  人"}}</div>
      <div class="textColor divWidth32">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.userId" placeholder="选择联系人" clearable="true"
                   filterable="true">
          <el-option v-for="item in userList" :key="item.id" :label="item.full_name" :value="item.id"></el-option>
        </el-select>
      </div>
    </div>
    <div style="display: flex; flex-direction: row; justify-content: space-between">
      <div class="textColor divWidth16" style="line-height: 250%">{{"联系方式"}}</div>
      <div class="textColor divWidth32 textPadding">
        <el-select :disabled="!buttonShow" class="contactSelect" v-model="busData.contactPhone" placeholder="选择联系电话" clearable="true"
                   filterable="true">
          <el-option v-for="item in contactPhones" :key="item.phone" :label="item.name" :value="item.phone"></el-option>
        </el-select>
      </div>
      <div class="textColor divWidth16" style="line-height: 250%">{{"联系方式"}}</div>
      <div class="textColor divWidth32 textPadding" style="line-height: 250%">{{getUserMobile()}}</div>
    </div>

    <div class="bottomLine" style="height:5%;display: flex; flex-direction: row; justify-content: space-between">
      <div class="textDiv divWidth16">{{"报价信息"}}</div>
      <div class="divWidth32"></div>
      <div class="divWidth32"></div>
      <div class="divWidth16"></div>
    </div>
    <div style="display: flex;flex-direction: column;align-items: center">
    <div class="tempItem textColor" style="background-color: whitesmoke; width: 120%; padding: 0px;position: relative">
      <div class="outSideDiv textAlignCenter"/>
      <div style="width: 42%;height: 100%" class="bottomLine1 borderL textAlignCenter">{{"产品名称"}}</div>
      <div style="width: 12%;" class="bottomLine1 textAlignCenter">授权方式</div>
      <div style="width: 8%;height: 100%" class="bottomLine1 textAlignCenter">{{"数量"}}</div>
      <div class="bottomLine1 textAlignCenter" style="width: 15%;height: 100%">{{"含税单价"}}</div>
      <div class="bottomLine1 textAlignCenter" style="width:8%;height: 100%">{{"税率"}}</div>
      <div class="bottomLine1 borderR textAlignCenter" style="width: 15%;height: 100%">{{"含税总价"}}</div>
      <div class="outSideDiv textAlignCenter">
        <span>{{"折扣/%"}}</span>
      </div>
      <div style="width: 95px;text-align: center;position: absolute;left: 100%;line-height: 220%">
        <span>提成</span>
      </div>
      <div style="width: 95px;text-align:center;position: absolute;left: calc(100% + 95px);line-height: 220%">
        <span>利润</span>
      </div>
    </div>
    </div>
    <div style="display: flex;flex-direction: column;align-items: center">
      <div v-for="item in this.busData.itemList" :key="item.id" style="width: 120%;padding: 0px;position: relative" class="tempItem textColor" :style="(getIndex(item.nanoid) + 1) % 2 !== 0 ? 'background-color: #E2EFDA' : 'background-color: white'">
        <div class="outSideDiv textAlignCenter">
          <el-button v-if="buttonShow" type="primary" @click="deleteItem(item.nanoid)">删除</el-button>
        </div>
        <div style="width: 42%;" class="bottomLine1 borderL textAlignCenter">
          <el-cascader :disabled="!buttonShow" v-model="item.product_id" :options="catalogWithProducts" style="width: 100%"
                       :props="props" :show-all-levels="false" placeholder="选择商品"  @change="onProductSelect(item)" clearable filterable/>
        </div>
        <div style="width: 12%;" class="bottomLine1 textAlignCenter">
          <el-select :disabled="!buttonShow" v-model="item.authorize_type" placeholder="授权方式"  @change="onProductSelect(item)" >
            <el-option v-for="item in authorizeTypeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </div>
        <div style="width: 8%;" class="bottomLine1 textAlignCenter">
          <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item)" v-model="item.cnt" :min="0" :max="200" placeholder="数量" class="inputNum" size="small"/>
        </div>
        <div class="bottomLine1 textAlignCenter" style="width: 15%">
          <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item,'price')" v-model="item.market_price_with_maintain_sale" :min="0" placeholder="单价" class="inputPrice" size="small"/>
        </div>
        <div class="bottomLine1 textAlignCenter" style="width: 8%">{{ item.tax_rate + "%"}}</div>
        <div class="bottomLine1 borderR textAlignCenter" style="width: 15%">{{"￥" + this.formatMoney(item.cnt * item.market_price_with_maintain_sale)}}</div>
        <div class="outSideDiv textAlignCenter">
          <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item,'ratio')" v-model="item.discount_ratio" :min="0" :max="100" placeholder="折扣" class="inputNum" size="small"/>
        </div>
        <div v-if="showCommission" style="width: 95px;text-align: center;position: absolute;left: 100%;line-height: 220%">
          {{item.commission}}
        </div>
        <div v-if="showProfit" style="width: 95px;text-align:center;position: absolute;left: calc(100% + 95px);line-height: 220%">
          {{item.profit}}
        </div>
      </div>
    </div>

    <div style="display: flex;flex-direction: column;align-items: center">
    <div class="tempTitle textColor" style="background-color: white;width: 120%;padding: 0px;height: 100%;position: relative">
      <div class="outSideDiv textAlignCenter">
        <el-button v-if="buttonShow" type="primary" @click="addItem">添加</el-button>
      </div>
      <div class=" borderL bottomLine" style="width: 84%; text-align: right;padding: 0px 2px; line-height: 3">{{"首年费用合计"}}</div>
      <div class="divWidth16 borderR bottomLine" style="height:100%;text-align: center; line-height:300%;border-left: 1px solid #4E7291">{{"￥" + this.formatMoney(this.busData.market_amount)}}</div>
      <div class="outSideDiv textAlignCenter"/>
      <div style="width: 95px;text-align: center;position: absolute;left: 100%;line-height: 220%">{{this.busData.total_commission}}</div>
      <div style="width: 95px;text-align:center;position: absolute;left: calc(100% + 95px);line-height: 220%">{{this.busData.total_profit}}</div>
    </div>
    </div>
<!--    <div class="tempItem textColor borderL borderR bottomLine1" style="background-color: whitesmoke;">-->
<!--      <div style="width: 44%;" class="textAlignCenter">{{"产品名称"}}</div>-->
<!--      <div style="width: 8%" class="textAlignCenter">{{"数量"}}</div>-->
<!--      <div class="divWidth16 textAlignCenter">{{"含税单价"}}</div>-->
<!--      <div class="divWidth16 textAlignCenter">{{"税率"}}</div>-->
<!--      <div class="divWidth16 textAlignCenter">{{"含税总价"}}</div>-->
<!--    </div>-->
<!--    <div style="display: flex;flex-direction: column;align-items: center">-->
<!--    <div v-for="item in this.busData.itemList" :key="item.id" v-show="(item.code !== 'NET' && !item.code.match('maintain')) && !(!buttonShow && item.maintain_cnt === 0) " style="width: 120%;padding: 0px" class="tempItem textColor" :style="(getIndex(item.nanoid) + 1) % 2 !== 0 ? 'background-color: #E2EFDA' : 'background-color: white'">-->
<!--      <div class="outSideDiv textAlignCenter">-->

<!--      </div>-->
<!--      <div style="width: 44%;text-align: left" class="bottomLine1 borderL textAlignCenter">-->
<!--        {{getProductName(item)}}-->
<!--      </div>-->
<!--      <div style="width: 8%;" class="bottomLine1 textAlignCenter">-->
<!--        <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item)" v-model="item.maintain_cnt" :min="0" :max="200" placeholder="数量" class="inputNum" size="small"/>-->
<!--      </div>-->
<!--      <div class="divWidth16 bottomLine1 textAlignCenter">-->
<!--        <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item,'price')" v-model="item.maintain_market_price_sale" :min="0" placeholder="单价" class="inputPrice" size="small"/>-->
<!--      </div>-->
<!--      <div class="divWidth16 bottomLine1 textAlignCenter">{{"6%"}}</div>-->
<!--      <div class="divWidth16 bottomLine1 borderR textAlignCenter">{{"￥" + this.formatMoney(item.maintain_cnt * item.maintain_market_price_sale)}}</div>-->
<!--      <div class="outSideDiv textAlignCenter">-->
<!--        <el-input-number :disabled="!buttonShow" @change="countTotalPrice(item,'ratio')" v-model="item.maintain_discount_ratio" :min="0" :max="100" placeholder="折扣" class="inputNum" size="small"/>-->
<!--      </div>-->
<!--    </div>-->
<!--    </div>-->
<!--    <div class="tempTitle textColor borderL borderR bottomLine" style="background-color: white;">-->
<!--      <div style="width: 84%; text-align: right;padding: 0px 2px">{{"总运维费用"}}</div>-->
<!--      <div class="divWidth16" style="height:100%;text-align: center; line-height:300%;border-left: 1px solid #4E7291">{{"￥" + this.formatMoney(this.busData.maintain_amount)}}</div>-->
<!--    </div>-->
    <div style="width: 100%; height: 6%; border-right: 2px solid #4E7291">
    </div>
    <div class="tempTitle textColor border" style="background-color: white;">
      <div class="divWidth16" style="height: 100%;line-height:400%;border-right: 2px solid #4E7291">{{"合同总金额:"}}</div>
      <div>{{"人民币大写：" + this.busData.total_amount_capital}}</div>
      <div class="divWidth16" style="height: 100%;text-align: center;line-height:400%; border-left: 2px solid #4E7291">{{"￥" + this.formatMoney(this.busData.total_amount)}}</div>
    </div>

    <div class="tempTitle textColor" style="background-color: white; height: 8%">
      <div class="divWidth16">{{"以下空白"}}</div>
      <div class="divWidth16">{{"提成：" + this.busData.total_count_rate + "套"}}</div>
      <div class="divWidth32">
        <span style="color: red">{{"*"}}</span>
        <span>{{"法务："}}</span>
        <el-select :disabled="!buttonShow" v-model="this.busData.legal" @change="countTotalPrice()" style="width: 90px">
          <el-option
              v-for="item in legalOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="this.showGain" class="divWidth32">{{"利润：" + this.busData.gain + "/利润率：" + this.busData.gain_rate + "%"}}</div>
    </div>

    <div class="tempTitle" style="height: 8%"></div>
    <div class="tempTitle" style="background-color: white;height: 8%"></div>

    <div class="bottomLine" style="height:5%;display: flex; flex-direction: row; justify-content: space-between">
      <div class="textDiv divWidth16">{{"付款方式"}}</div>
      <div class="divWidth32"></div>
      <div v-if="buttonShow" style="width: 50%;display: flex;flex-direction: row;justify-content: flex-end;">
        <el-radio-group v-model="busData.pay_type" @change="getPayPrecent">
          <el-radio-button label="pay55" >55分期</el-radio-button>
          <el-radio-button label="pay64" >64分期</el-radio-button>
          <el-radio-button label="pay73" >73分期</el-radio-button>
          <el-radio-button label="pay82" >82分期</el-radio-button>
          <el-radio-button label="pay100" >全款</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div style="height: 3%;margin-bottom: 4px; background-color: whitesmoke"></div>
    <div class="tempTitle textBottom">
      <el-input :disabled="!buttonShow" class="payContentInput" style="color: #4E7291" type="textarea" :autosize="{ minRows: 1, maxRows: 4 }" resize="none" v-model="this.busData.pay_content" placeholder="请输入" />
    </div>
    <div class="tempTitle textBottom"></div>
    <div class="tempTitle textBottom">
      <span style="width:39%" class="textAlignRight">{{"本次软件对象及最终使用单位为："}}</span>
      <el-input :disabled="!buttonShow" style="color: #4E7291" type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" resize="none" v-model="this.busData.last_company_name" placeholder="请输入" />
    </div>
    <div class="tempTitle textBottom">
      <span style="width:39%" class="textAlignRight">{{"English name："}}</span>
      <el-input :disabled="!buttonShow" style="color: #4E7291" type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" resize="none" v-model="this.busData.last_company_name_en" placeholder="please enter" />
    </div>
    <div class="tempTitle textBottom">
      <span style="width:39%" class="textAlignRight">{{"使用地址："}}</span>
      <el-select :disabled="!buttonShow" style="width: 95%" class="contactSelect" v-model="busData.last_company_address" placeholder="选择地址"
                 filterable="true" @change="getLastCompanyAddressEn">
        <el-option v-for="item in companyAddress" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="tempTitle textBottom">
      <span style="width:39%" class="textAlignRight">{{"Use address："}}</span>
      <el-input :disabled="!buttonShow" style="color: #4E7291" type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" resize="none" v-model="this.busData.last_company_address_en" placeholder="please enter" />
    </div>

    <div class="bottomLine" style="height:5%;display: flex; flex-direction: row; justify-content: space-between">
      <div class="textDiv divWidth16">{{"备注"}}</div>
      <div class="divWidth32"></div>
      <div class="divWidth16"></div>
      <div class="divWidth32"></div>
    </div>
    <div style="height: 3%; background-color: whitesmoke"></div>
    <div class="tempTitle" style="background-color: white;">
      <el-input :disabled="!buttonShow" style="color: #4E7291" v-model="busData.remark" placeholder="请输入" />
    </div>

    <div class="bottomLine" style="height:5%;display: flex; flex-direction: row; justify-content: space-between">
      <div class="textDiv divWidth16">{{"收款信息"}}</div>
      <div class="divWidth32"></div>
      <div class="divWidth16"></div>
      <div class="divWidth32"></div>
    </div>
    <div style="height: 3%; margin-bottom: 4px; background-color: whitesmoke"></div>
    <div class="tempTitle textBottom">{{"开 户 名 ：" + this.selfCompany.account_name}}</div>
    <div class="tempTitle textBottom">{{"开 户 行 ：" + this.selfCompany.bank_name}}</div>
    <div class="tempTitle textBottom">{{"收款账号：" + this.selfCompany.account_number}}</div>
    <div class="tempTitle" style="height: 2%"></div>
    <el-button v-if="!this.parentData.content_json" @click="addQuote" :loading="loading" type="primary">创建报价单</el-button>

    <el-watermark :gap="[200,200]" :font="font" :content="content" style="position:unset;">
    </el-watermark>
</div>
</div>
</template>

<script>
import { useDateFormat } from '@vueuse/core';
import {nanoid} from "nanoid";
export default {
  name: "MakeQuote335Temp",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  computed: {
    authorizeTypeList() {
      return this.$store.getters['core/getDictList']('authorize_type');
    },
  },


  data(){
    return{
      chanceList:[],
      potentialList:[],
      companyAllList:[],
      companyList:[],
      chanceDetailList:[],
      potentialInfoList:[],
      quote:[],
      quoteJson:"",
      props: {
        emitPath:false,
        expandTrigger: 'hover',
        value: 'id',
        label: 'name'
      },
      showPotential:false,
      showCommission:true,
      showProfit:true,
      legalOptions:[
        {
          value:false,
          label:"否",
        },
        {
          value:true,
          label:"是",
        }
      ],
      showGain:false,
      loading:false,
      companyAddress:[],
      contactPhones:[],
      contactList:[],
      selfCompanyList:[],
      userList:[],
      productAll: [],
      catalogWithProducts: [],
      busData: {
        pay_content:'',
        company_address:'',
        contactPhone:'',
        legal:null,
        selfCompanyId:'',
        userId:'',
        gain:0,
        gain_rate:0,
        lic_type: 'single',
        single:0,
        net:40000,
        net_num:0,
        net_count_rate:0,
        pay_type: 'pay64',
        first_year_maintain: 'combine',
        maintain_years: 3,
        net_cost: 40000,
        customerSealed: false,
        fileGenerateType: 'system_generate',
        uploadFileIds: [],
        first_year_amount: 0,
        next_year_amount: 0,
        tax_amount: 0,
        cost:0,
        total_amount: 0,
        total_amount_capital: '',
        market_amount:0,
        maintain_amount:0,
        personal_bonus: 0,
        gross_profit: 0,
        total_count_rate:0,
        contactId: '',
        chanceId: '',
        remark: '软件交货期10个工作日，软件支持降版本安装。',
        itemList: [],
        contractVariableList: [],
        quoteTemplateId: ''
      },
      selfCompany:{},
      currDate:'',
      effectiveDay:'',
      url:"",
      buttonShow:true,
      font:{
        color: '#d6d5d5'
      },
      content:"JOYSUN"
    }
  },
  methods:{
    async getFileUrl() {
      let object = await this.$http('crmService.getFile', this.parentData)
      this.url = object.url
    },

    // async getCompanyByChanceId(){
    //   let object =  await this.$http('crmQuoteService.getCompanyByChanceId',this.parentData)
    //   if (!this.parentData.content_json) {
    //     this.busData.company_name = object.name
    //     this.busData.company_address = object.address
    //     this.busData.last_company_name = object.name
    //     this.busData.last_company_address = object.address
    //     this.busData.last_company_name_en = object.name_en
    //     this.busData.last_company_address_en = object.address_en
    //   }
    //   let address1 = {
    //     id:object.address_register,
    //     name:object.address_register,
    //     nameEn:object.address_register_en,
    //   }
    //   let address2 = {
    //     id:object.address,
    //     name:object.address,
    //     nameEn:object.address_en,
    //   }
    //   this.companyAddress.push(address1,address2)
    // },

    async getQuotesByChanceId(){
      if(!this.busData.chanceId){
        return;
      }
      let params = {chance_id: this.busData.chanceId }
      let object =  await this.$http('crmQuoteService.getQuotesByChanceId',params)
      this.quote = object
    },

    //获取是否展示提成和利润
    async getShowCommissionAndProfit(){
      let data = await this.$http('crmQuoteService.getShowCommissionAndProfit');
      this.showCommission = data.showCommission;
      this.showProfit = data.showProfit;
    },

    //获取联系人
    async getCompanyContactList(chanceId) {
      if(this.parentData.chance_id){
        chanceId = this.parentData.chance_id
      }
      let params = {chance_id: chanceId}
      this.contactList = await this.$http('crmChanceService.getCompanyContact', params)
    },

    //获取公司
    async getSelfCompanyList() {
      this.selfCompanyList = await this.$http('crmQuoteService.getSelfCompanyList')
    },

    //获取当前登陆人所相关的所有公司，以及公司下的机会和机会下的潜力产品
    async getUserCompanyList() {
      let data = await this.$http('crmQuoteService.getCompanyByUser');
      this.companyAllList = data.companyInfoList;
      this.chanceDetailList = data.chanceList;
      this.potentialInfoList = data.potentialInfoList;
    },

    //当前选中的公司 去匹配公司的基本信息
    async getCompanyInfo(){
      for (let item of this.companyAllList){
        if (item.id === this.busData.company_id) {
          this.busData.company_name = item.name;
          this.busData.company_address = item.address;
          this.busData.last_company_name = item.name;
          this.busData.last_company_address = item.address;
          this.busData.last_company_name_en = item.name_en;
          this.busData.last_company_address_en = item.address_en;
          let address1 = {
            id: item.address_register,
            name: item.address_register,
            nameEn: item.address_register_en,
          }
          let address2 = {
            id: item.address,
            name: item.address,
            nameEn: item.address_en,
          }
          if(address1.name){
            this.companyAddress.push(address1)
          }
          if(address2.name){
            this.companyAddress.push(address2)
          }

        }
      }
      //获取机会List
      if(this.chanceDetailList){
        for(let item of this.chanceDetailList){
          if(item){
            if(item.company_id === this.busData.company_id){
              this.chanceList.push(item);
            }
          }
        }
      }
    },

    //根据关键字带出公司
    getCompanyByRemote(value){
      if(value){
        this.companyList = [];
        for (let i = 0; i < this.companyAllList.length; i++) {
          let item = this.companyAllList[i]
          if(item && item.name && item.name.trim() !== ''){
            let name = item.name.toLowerCase();
            value = value.toLowerCase();
            if(name.includes(value)){
              this.companyList.push(item)
            }
            if(item.id === value){
              this.companyList.push(item)
            }
          }
        }
      }else {
        this.companyList = []
      }
    },
    //根据机会编号带出潜力产品
    getPotentialByChance(){
      if(this.busData.chanceId){
        this.potentialList = [];
        for (let item of this.potentialInfoList){
          if(item.chance_id === this.busData.chanceId){
            let product = item.product_id
            //找产品
            for(let productInfo of this.productAll){
              if( product === productInfo.id){
                this.potentialList.push(productInfo)
              }
            }
          }
        }
        if(this.potentialList.length > 0){
          this.showPotential = true;
        }else {
          this.showPotential = false;
          this.busData.potentialId = '';
        }
        this.getCompanyContactList(this.busData.chanceId);

        //获取以往报价单
        this.getQuotesByChanceId();
      }
    },

    async getSelfCompanyDefault(){
      await this.getSelfCompanyList()
      this.busData.selfCompanyId = this.selfCompanyList[0].id
      this.selfCompany = this.selfCompanyList[0]
    },

    //获取用户联系人
    async getUserContactList() {
      this.userList = await this.$http('crmQuoteService.getUsers')
    },

    //获取利润是否展示
    async getShowGain() {
      this.showGain = await this.$http('crmQuoteService.showGain')
    },

    async getCatalogWithProducts() {
      this.catalogWithProducts = await this.$http('crmProductCatalogService.getCatalogWithProducts')
      //从目录树里面获取所有产品，不要再从后端读一次
      this.productAll = []
      this.readProducts(this.catalogWithProducts)
    },

    getLastCompanyAddressEn(){
      this.companyAddress.forEach((item) => {
        if (item.id === this.busData.last_company_address){
          this.busData.last_company_address_en = item.nameEn
        }
      })
    },

    getQuoteJson(){
      this.busData = JSON.parse(this.quoteJson)
    },

    getSelfCompany(){
      this.selfCompanyList.forEach((item) => {
        if (item.id === this.busData.selfCompanyId){
          this.selfCompany = item
        }
      })
    },

    getUserMobile(){
      let mobile = ''
      this.userList.forEach((item) => {
        if (item.id === this.busData.userId){
          mobile = item.mobile
        }
      })
      return mobile
    },

    addQuote() {
      if(this.busData.contactId == ''){
        return this.$message.error(`甲方联系人未选择`);
      }

      if(this.busData.userId == ''){
        return this.$message.error(`乙方联系人未选择`);
      }

      if(this.busData.legal === null){
        return this.$message.error(`请确认法务`);
      }

      // this.busData.chanceId = this.parentData.chance_id;
      this.loading = true;

      this.$http('crmQuoteService.makeQuote335New', this.busData).then(data => {
        this.loading = false;
        this.$message.success("创建成功");
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },

    readProducts(catalogList) {
      if (!catalogList || catalogList.length == 0) {
        return;
      }

      for (var i = 0; i < catalogList.length; i++) {
        var busObject = catalogList[i]
        if (busObject.is_product == true) {
          //
          // //处理本体和运维价格
          // //销售价  软件本体
          // busObject.market_price = this.getProductPrice(busObject, 'software')?.price || 0;
          // //税率 软件本体
          // busObject.tax_rate = this.getProductPrice(busObject, 'software')?.tax_rate || 13;
          // //套数折算比例 软件运维
          // busObject.maintain_count_rate = this.getProductPrice(busObject, 'maintain')?.count_rate || 0;
          // //销售价 软件运维
          // busObject.maintain_market_price = this.getProductPrice(busObject, 'maintain')?.price || 0;
          // //成本价 软件运维
          // busObject.maintain_market_price_cost = this.getProductPrice(busObject, 'maintain')?.cost || 0;
          // //套数折算比例  本体含运维
          // busObject.market_with_maintain_count_rate = this.getProductPrice(busObject, 'software_with_maintain')?.count_rate || 0;
          // //销售价 本体含运维
          // busObject.market_price_with_maintain = this.getProductPrice(busObject, 'software_with_maintain')?.price || 0;
          // //成本价 本体含运维
          // busObject.market_price_with_maintain_cost = this.getProductPrice(busObject, 'software_with_maintain')?.cost || 0;
          //
          // //软件运维
          // if (busObject.code.match('maintain')){
          //   busObject.market_with_maintain_count_rate = this.getProductPrice(busObject, 'maintain')?.count_rate || 0;
          //   busObject.market_price_with_maintain = this.getProductPrice(busObject, 'maintain')?.price || 0;
          //   busObject.market_price_with_maintain_cost = this.getProductPrice(busObject, 'maintain')?.cost || 0;
          //   busObject.tax_rate = this.getProductPrice(busObject, 'maintain')?.tax_rate || 6;
          // }
          // //网络搭建
          // if (busObject.id === "63e07a08d4d26286c374b084"){
          //   console.log(busObject.code)
          //   busObject.market_price_with_maintain = this.getProductPrice(busObject, 'software')?.price || 0;
          //   busObject.market_price_with_maintain_cost = this.getProductPrice(busObject, 'software')?.cost || 0;
          //   busObject.maintain_count_rate = this.getProductPrice(busObject, 'software')?.count_rate || 0;
          // }
          this.productAll.push(busObject);
        } else {
          this.readProducts(busObject.children)
        }
      }
    },

    getProductPrice(product, authorizeType){
      if(product == null || authorizeType == null || product.price_list == null || product.price_list.length == 0){
        return null;
      }

      for (var i = 0; i < product.price_list.length; i++) {
        if (product.price_list[i].authorize_type == authorizeType) {
          return product.price_list[i];
        }
      }
      return null;
    },

    getProductById(productId) {
      for (var i = 0; i < this.productAll.length; i++) {
        if (this.productAll[i].id == productId) {
          return this.productAll[i];
        }
      }
      return null;
    },

    // getProductName(item){
    //   if (item.product_ids && item.product_ids.length !== 0) {
    //     let product = this.getProductById(item.product_ids[item.product_ids.length - 1])
    //     if (product) {
    //       return "(维护)" + product.name
    //     } else {
    //       return " "
    //     }
    //   }else {
    //     return " "
    //   }
    // },

    onProductSelect(item) {
      if (!item.product_id) {
        item.product_id = '';
        item.authorize_type = '';
        item.cnt = 0;
        item.unit = '';
        item.market_price = 0;
        item.market_price_with_maintain_sale = 0;
        item.tax_rate = 0;
        item.discount_ratio = 0;
        item.commission = 0;
        item.profit = 0;
        item.count_rate = 0;
        item.legal_price = 0;
        //计算提成
        this.calcCommission();
        //计算利润
        this.calcProfit();
        //计算提成套数
        this.calcCountRate();
        // this.countTotalPrice(1);
        return
      }

      var productId = item.product_id

      var product = this.getProductById(productId);
      if (!product) {
        return this.$message.error("未找到商品,id:" + productId);
      }
      var authorizeType = item.authorize_type;

      item.unit = product.unit;
      //计算价格 根据授权方式计算
      let priceList = product.price_list;
      if(priceList){
        for (let price of priceList){
          if(price.authorize_type === authorizeType){
            item.market_price = price.price;
            item.market_price_with_maintain_sale = price.price;
            item.tax_rate = price.tax_rate;
            item.cost = price.cost;
            item.count_rate = price.count_rate;
            item.legal_price = price.legal_cost;
          }
        }
      }
      //计算提成
      this.calcCommission();
      //计算利润
      this.calcProfit();
      //计算提成套数
      this.calcCountRate();
      //
      // item.market_price = product.market_price;
      // item.market_price_with_maintain = product.market_price_with_maintain;
      // item.market_price_with_maintain_cost = product.market_price_with_maintain_cost;
      // item.market_price_with_maintain_sale = product.market_price_with_maintain;
      // item.market_with_maintain_count_rate = product.market_with_maintain_count_rate
      //
      // item.maintain_count_rate = product.maintain_count_rate
      // item.maintain_market_price = product.maintain_market_price;
      // item.maintain_market_price_cost = product.maintain_market_price_cost;
      // item.maintain_market_price_sale = product.maintain_market_price;
      // item.market_price_format = this.formatMoney(item.market_price);
      // item.tax_rate = product.tax_rate;
      // item.code = product.code
      // this.countTotalPrice(item,'price')
    },
    //计算提成  后续写出提成管理后 需要从提成管理获取 提成比例  目前先写死 可能需要计算税后的 目前是税前
    calcCommission(){
      for (let item of this.busData.itemList) {
        let commissionRatio = this.calcCommissionType(item.discount_ratio,item.authorize_type);
          //法务
          let legalPrice = 0;
          if (this.busData.legal === true) {
            if(item.legal_price){
              legalPrice = item.legal_price;
            }
          }

          if (item.cnt && item.market_price_with_maintain_sale && item.cost) {
            // 套数 * (市场价 - 成本 - 法务费) * (1- 税率)  * 提成比例
            let commissionPrice = (item.cnt * ( (item.market_price_with_maintain_sale - item.cost - legalPrice ) * (1-item.tax_rate * 0.01)  ) * commissionRatio)
            item.commission = Number(commissionPrice.toFixed(2));
          }
      }
      this.busData.total_amount = 0;
      this.busData.total_commission = 0;
      for (let item of this.busData.itemList){
        if(item.commission){
          this.busData.total_commission = this.busData.total_commission + item.commission;
        }
        if(item.cnt && item.market_price_with_maintain_sale){
          this.busData.total_amount = this.busData.total_amount + item.cnt * item.market_price_with_maintain_sale;
        }
      }
      //保留2位小数 格式化
      this.busData.total_amount = Number(this.busData.total_amount.toFixed(2));
      this.busData.total_commission = Number(this.busData.total_commission.toFixed(2));

      this.busData.market_amount = this.busData.total_amount;

    },
    //提成分类
    calcCommissionType(discount_ratio,authorizeType){
      if(!authorizeType || !discount_ratio){
        return ;
      }
      let commissionRatio = 0;
      //软件本体
      if (discount_ratio && 'software,software_with_maintain'.includes(authorizeType)) {
        console.log('1111')
        if (discount_ratio >= 90) {
          commissionRatio = 0.05
        }
        if (90 > discount_ratio && discount_ratio >= 80) {
          commissionRatio = 0.04
        }
        if (80 > discount_ratio && discount_ratio >= 70) {
          commissionRatio = 0.03
        }
        if (70 > discount_ratio && discount_ratio >= 65) {
          commissionRatio = 0.02
        }
        if (65 > discount_ratio) {
          commissionRatio = 0.01
        }
        if (this.busData.legal === true) {
          commissionRatio = commissionRatio - 0.005
          if (commissionRatio < 0.005) {
            commissionRatio = 0.005;
          }
        }
      }
      //软件运维
      if (discount_ratio && authorizeType === 'maintain') {
        if (discount_ratio >= 80) {
          commissionRatio = 0.03
        }
        if (80 > discount_ratio && discount_ratio >= 60) {
          commissionRatio = 0.015
        }
        if (60 > discount_ratio) {
          commissionRatio = 0.005
        }
      }
      return commissionRatio;
    },
    //计算利润
    calcProfit(){
      for(let item of this.busData.itemList) {
        //法务
        let legalPrice = 0;
        if (this.busData.legal === true) {
          if(item.legal_price){
            legalPrice = item.legal_price;
          }
        }

        if (item.cnt && item.market_price_with_maintain_sale && item.cost) {
          //利润 = 套数 * ( (市场价 - 成本 - 法务费) * (1- 税率) - 提成 )
          let profitPrice = (item.cnt * ( (item.market_price_with_maintain_sale - item.cost - legalPrice ) * (1-item.tax_rate * 0.01) - item.commission ))
          item.profit = Number(profitPrice.toFixed(2));
        }
      }
      this.busData.total_cost = 0;
      this.busData.total_amount = 0;
      this.busData.total_profit = 0;
      for (let item of this.busData.itemList){
        if(item.profit){
          this.busData.total_profit = this.busData.total_profit + item.profit;
        }
        if(item.cnt && item.market_price_with_maintain_sale){
          this.busData.total_amount = this.busData.total_amount + item.cnt * item.market_price_with_maintain_sale;
        }
        //原价 总价
        if(item.cnt && item.cost){
          this.busData.total_cost = this.busData.total_cost + item.cnt * item.cost;
        }
      }
      this.busData.total_amount = Number(this.busData.total_amount.toFixed(2));
      this.busData.total_profit = Number(this.busData.total_profit.toFixed(2));
      this.busData.total_amount_capital = this.$sysMethod.numToCapital(this.busData.total_amount)

      //利润率 (卖价-成本-法务费）*(1-税率) -提成）/卖价 === ?   总利润 /    （（（卖价 *（1-税率））* 套数 ） for 计算总卖价）
      let salesPriceTotal = 0;
      for (let item of this.busData.itemList){
        salesPriceTotal = salesPriceTotal + item.cnt * item.market_price_with_maintain_sale * (1 - item.tax_rate * 0.01);
      }

      this.busData.gain_rate = Number(((this.busData.total_profit / salesPriceTotal) * 100).toFixed(2));
      this.busData.gain = this.busData.total_profit;

      this.busData.market_amount = this.busData.total_amount;
    },
    //计算折扣或者销售价
    countTotalPrice(item,res){
      if(res === 'price'){
        item.discount_ratio = Number((item.market_price_with_maintain_sale/item.market_price *100).toFixed(2))
      }
      if(res === 'ratio'){
        item.market_price_with_maintain_sale = item.market_price * item.discount_ratio / 100
      }
      //计算提成
      this.calcCommission();
      //计算利润
      this.calcProfit();
      //计算提成套数
      this.calcCountRate();
    },
    //计算提成套数
    calcCountRate(){
      this.busData.total_count_rate = 0
      for (let item of this.busData.itemList) {
        if (item.count_rate && item.cnt) {
          this.busData.total_count_rate = this.busData.total_count_rate + (item.cnt * item.count_rate);
        }
      }
    },


    // countTotalPrice(item1,res){
    //   if (item1.product_id || item1 === this.busData[this.busData.lic_type]) {
    //     if (res === 'price'){
    //       item1.discount_ratio = Number((item1.market_price_with_maintain_sale/item1.market_price_with_maintain).toFixed(2))*100
    //       item1.maintain_discount_ratio = Number((item1.maintain_market_price_sale/item1.maintain_market_price).toFixed(2))*100
    //     }else if (res === 'ratio') {
    //       item1.market_price_with_maintain_sale = item1.market_price_with_maintain*item1.discount_ratio/100
    //       item1.maintain_market_price_sale = item1.maintain_market_price*item1.maintain_discount_ratio/100
    //     }
    //     this.busData.market_amount = 0
    //     this.busData.total_amount = 0
    //     this.busData.maintain_amount = 0
    //     this.busData.cost = 0
    //     this.busData.total_count_rate = 0
    //     for (var i = 0; i < this.busData.itemList.length; i++) {
    //       var item = this.busData.itemList[i]
    //
    //       if (item.product_id) {
    //         this.busData.market_amount += item.market_price_with_maintain_sale * item.cnt
    //         this.busData.maintain_amount += item.maintain_market_price_sale * item.maintain_cnt
    //         this.busData.cost += item.market_price_with_maintain_cost * item.cnt
    //         this.busData.cost += item.maintain_market_price_cost * item.maintain_cnt
    //         this.busData.total_count_rate += item.market_with_maintain_count_rate * item.cnt
    //         this.busData.total_count_rate += item.maintain_count_rate * item.maintain_cnt
    //       }
    //     }
    //
    //     this.busData.total_amount = this.busData.market_amount + this.busData.maintain_amount
    //
    //     if (this.busData.lic_type === 'net') {
    //       this.busData.market_amount += this.busData[this.busData.lic_type] * this.busData.net_num
    //       this.busData.total_amount = this.busData.total_amount + this.busData[this.busData.lic_type] * this.busData.net_num;
    //       this.busData.cost += this.busData.net_cost * this.busData.net_num
    //       this.busData.total_count_rate += this.busData.net_count_rate
    //     }
    //     this.busData.gain = (this.busData.total_amount - this.busData.cost).toFixed(2)
    //     this.busData.gain_rate = (this.busData.total_amount - this.busData.cost)/this.busData.total_amount*100
    //     this.busData.gain_rate = this.busData.gain_rate.toFixed(2)
    //     this.busData.total_amount_capital = this.$sysMethod.numToCapital(this.busData.total_amount)
    //   }
    // },

    //将数字转换成金额显示
    formatMoney(num) {
      num = num.toFixed(2);
      num = parseFloat(num)
      num = num.toLocaleString();
      return num;//返回的是字符串23,245.12保留2位小数
    },

    getToday(){
      this.currDate = useDateFormat(new Date(), 'YYYY年M月DD日')
    },

    getEffectiveDay(){
      let date1 = new Date();
      let date2 = new Date(date1);
      date2.setDate(date1.getDate() + 30);
      this.effectiveDay = useDateFormat(date2,'YYYY年M月DD日')
    },

    addItem(){
      let item = {
        nanoid: nanoid(),
        market_price_with_maintain_sale:0,
        tax_rate:0,
        cnt:0,
        maintain_market_price_sale:0,
        maintain_cnt:0,
        maintain_discount_ratio:100,
        discount_ratio:100,
        code:'NET'
      }
      this.busData.itemList.push(item)
    },

    deleteItem(nanoid){
      let index = this.busData.itemList.findIndex(item => item.nanoid === nanoid);
      this.busData.itemList.splice(index, 1);
    },

    getIndex(nanoid) {
      let index = this.busData.itemList.findIndex(item => item.nanoid === nanoid);
      return index
    },

    getPayPrecent(){
      if (this.busData.pay_type === "pay55"){
        this.busData.payPrecent = 50
      }
      if (this.busData.pay_type === "pay64"){
        this.busData.payPrecent = 60
      }
      if (this.busData.pay_type === "pay73"){
        this.busData.payPrecent = 70
      }
      if (this.busData.pay_type === "pay82"){
        this.busData.payPrecent = 80
      }
      this.busData.pay_content = "合同签订后10个工作日内甲方支付本体金额的" + this.busData.payPrecent + "%；交货安装并提交全额增值税专用发票后的10个工作日内支付软件本体尾款；"
      if (this.busData.pay_type === "pay100"){
        this.busData.payPrecent = 100
        this.busData.pay_content = "合同签订后10个工作日内甲方支付本体金额的" + this.busData.payPrecent + "%；"
      }
      this.busData.pay_content += "\r第二年度以及第三年度维护于上一年度维护到期时分期支付"
    },

    //调用方法获取联系方式
    async getContactPhone(res,id){
      this.contactPhones = []
      let params = {contact_id:id}
      this.contactPhones = await this.$http('companyOrganization.getContactPhoneById',params);
      if(this.contactPhones.length > 0){
        this.busData.contactPhone = this.contactPhones[0].phone
      }else {
        this.busData.contactPhone = '';
      }
    }
  },

  mounted() {
    this.getToday()
    this.getEffectiveDay()
  },

  async created() {
    if (this.parentData.content_json){
      console.log(this.parentData)
      this.buttonShow = false
      this.quoteJson = this.parentData.content_json
      this.busData = JSON.parse(this.parentData.content_json)
      //this.getFileUrl()
    }else {
      this.buttonShow = true
      for (let i = 0; i < 3; i++) {
        this.addItem()
      }
    }
    //获取当前公司list
    await this.getUserCompanyList();
    //是否展示提成和利润
    await this.getShowCommissionAndProfit();

    await this.getCatalogWithProducts()
    await this.getPayPrecent()
    // this.getCompanyByChanceId()
    if(this.parentData.chance_id){
      await this.getQuotesByChanceId()
      await this.getCompanyContactList()
    }
    if(this.busData.company_id){
      await this.getCompanyByRemote(this.busData.company_id);
    }
    if(this.busData.chanceId){
      await this.getPotentialByChance();
    }
    await this.getUserContactList()
    await this.getSelfCompanyDefault()
    await this.getShowGain()
    this.busData.userId = this.$store.state.core.currentUser?.id
    this.content = this.$store.state.core.currentUser?.full_name
  }
}
</script>

<style scoped>
.temp{
  width: 60%;
  height: 190%;
  display: flex;
  flex-direction: column;
}

.tempTitle{
  background-color: #4E7291;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 6%;
}

.tempItem{
  background-color: #4E7291;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 2px;
}

.textColor{
  color: #4E7291;
}

.bottomLine{
  border-bottom: 2px solid #4E7291;
}

.bottomLine1{
  border-bottom: 1px solid #4E7291;
}

.border{
  border: 2px solid #4E7291;
}

.borderL{
  border-left: 2px solid #4E7291;
}

.borderR{
  border-right: 2px solid #4E7291;
}

.textDiv{
  color: white;
  background-color: #4E7291;
  text-align: center;
  font-size: 16px;
  line-height: 200%;
}

.textBottom{
  background-color: white;
  color: #4E7291;
  margin-bottom: 4px
}

.divWidth16{
  width: 16%;
}

.divWidth32{
  width: 34%;
}

.inputNum{
  color: #4E7291;
  width: 100%;
}

.inputPrice{
  color: #4E7291;
  width: 100%;
}

.button{
  width: 100%;
  background: transparent;
  color: #4E7291;
  border: none;
}

.outSideDiv{
  width: 10%;
  height: 100%;
  background-color: white;
}

.textAlignCenter{
  height: 100%;
  text-align: center;
  line-height: 220%
}

.textAlignRight{
  height: 100%;
  text-align: left;
  line-height: 220%
}

.textPadding{
  padding: 1px 2px;
}

/deep/.el-input__wrapper{
  background-color: transparent;
}

/deep/.el-textarea__inner{
  color: #4E7291;
  box-shadow: none;
}

/deep/.el-input-number__decrease{
  background-color: transparent;
  border: none;
  color: #4E7291;
}

/deep/.el-input.is-disabled .el-input__wrapper {
  background-color: transparent;
  box-shadow: none;
}

/deep/.el-select .el-input.is-disabled .el-input__inner {
  -webkit-text-fill-color: #4E7291;
}

/deep/.el-input.is-disabled .el-input__inner {
  -webkit-text-fill-color: #4E7291;
}

/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #4E7291;
  background-color: transparent;
}

/deep/.el-input-number__increase{
  background-color: transparent;
  border: none;
  color: #4E7291;
}

/deep/.el-input--small .el-input__inner{
  color: #4E7291;
}

/deep/.el-input__wrapper{
  box-shadow: none;
}

/deep/.el-input__wrapper:hover{
  box-shadow: none;
  border: none;
}

/deep/.el-select .el-input.is-focus .el-input__wrapper{
  border: none;
}

/deep/.el-select .el-input__inner{
  color: #4E7291;
}

/deep/.el-select__wrapper {
  background-color: transparent;
  box-shadow: none;
  padding: unset;
}

/deep/.el-select__placeholder {
  color: #4E7291;
}
/deep/.el-select .el-input .el-select__caret.el-icon{
  color: #4E7291;
}

/deep/.el-cascader .el-input .el-input__inner{
  color: #4E7291;
}

/deep/.el-input__inner{
  color: #4E7291;
}

.contactSelect >>>.el-input__wrapper{
  padding: 1px 2px;
}

.contactPhone >>>.el-input__wrapper{
  padding: 1px 0px;
}

.quoteSelect >>>.el-input__inner{
  color: white;
}

.quoteSelect >>>.el-select__placeholder{
  color: #b8b9bb;
}

.quoteSelect >>>.el-input .el-select__caret.el-icon {
  color: white;
}

.payContentInput >>>.el-textarea__inner{
  padding: 1px 0px;
}
.el-select {
  width: 100%;
}
</style>